export enum HelpCentreContentType {
  video = 'Video',
  faq = 'FAQ',
  article = 'Article',
}
